<template>
  <div class='tasks' v-loading="isLoading">
    <div class="search-bar">
      <el-select v-model="selectedTaskFilter" value-key="attributes.name" placeholder="Select" class="task-select">
        <el-option v-for="type in taskTypes" :key="type.index" :label="type.name" :value="type.index" :disabled="type.disabled">
        </el-option>
      </el-select>
      <el-autocomplete v-model="searchInput" placeholder="Search" ref="task" class="task-search" :fetch-suggestions="filterAutocomplete">
        <div slot="suffix">
          <font-awesome-icon v-if="searchInput.length > 0" icon="times-circle" class="entry-search-icon clear" @click="searchInput = ''"/>
          <el-tooltip placement="top" content="Save search query" >
            <font-awesome-icon  icon="heart" class="entry-search-icon unsaved" @click="saveTaskQuery" v-if="searchInput.length > 0 && !currentSearchIsSaved"/>
          </el-tooltip>
          <el-tooltip placement="top" content="Remove search query" >
            <font-awesome-icon v-if="searchInput.length > 0 && currentSearchIsSaved" icon="heart" class="entry-search-icon saved" @click="removeTaskQuery"/>
          </el-tooltip>
          <font-awesome-icon v-if="searchInput.length === 0" icon="search" class="entry-search-icon" @click="saveTaskQuery"/>
        </div>
      </el-autocomplete>
    </div>

    <div class="table-row header">
      <div class="priority" @click="sortData('priority')" v-if="isPriorityVisible"><span>Priority</span><SortIcon column="priority" :sortProperty="$store.getters.taskSortProp" :sortAscending="$store.getters.taskSortAscending"></SortIcon></div>
      <div class="type" @click="sortData('type')" ><span>Type</span><SortIcon column="type" :sortProperty="$store.getters.taskSortProp" :sortAscending="$store.getters.taskSortAscending"></SortIcon></div>
      <div class="task" @click="sortData('taskString')"><span>Task</span><SortIcon column="taskString" :sortProperty="$store.getters.taskSortProp" :sortAscending="$store.getters.taskSortAscending"></SortIcon></div>
      <div class="status" @click="sortData('status')" v-if="isStatusVisible"><span>Status</span><SortIcon column="status" :sortProperty="$store.getters.taskSortProp" :sortAscending="$store.getters.taskSortAscending"></SortIcon></div>
    </div>

    <RecycleScroller :items="tasks" :item-height="30" class="tasks-table">
      <div slot-scope="{ item }" class="table-row" @click="selectTask(item, $event)" @contextmenu="handleRightClick(item)">
        <div class="priority" v-if="isPriorityVisible"><span>{{item.priority}}</span></div>
        <div class="type" ><span>{{capitalize(singularize(item.type))}}</span></div>
        <el-tooltip  :content="item.taskString" placement="top" :open-delay="tooltipDelay">
          <div class="task">
            <div class="tag success" type="success" size="mini">{{item.client || ' - - - '}}</div>
            <div class="tag primary" size="mini">{{item.projectPath}}</div>
            <div class="tag" :class="{'warning' : item.type && item.type === 'events', 'info' : item.type && item.type === 'tasks'}" size="mini">{{item.attributes.name}}</div >
          </div>
        </el-tooltip>
        <div class="status" v-if="isStatusVisible"><span :class="{'error': item.status ==='Done', 'warning': item.status==='On Hold'}">{{item.status}}</span></div>
      </div>
    </RecycleScroller>
    <context-menu id="context-menu" ref="ctxMenu">
      <li @click="openTaskInLp(rightClickedTask)" v-if="rightClickedTask">
        <el-button class="context-menu-button" size="mini" type="info" plain><font-awesome-icon icon='link' class="icon"/>Open task in LP</el-button>
      </li>
    </context-menu>
  </div>
</template>

<script>

import SortIcon from '@/components/SortIcon'
import contextMenu from 'vue-context-menu'
import moment from 'moment'
import { capitalize, singularize } from '@/utils/utils'

export default {

  props: {
    onSelect: Function,
    isActivityVisible: Boolean
  },
  components: {
    SortIcon,
    contextMenu
  },
  data () {
    return {
      currentRow: null,
      filteredResults: null,
      isLoading: false,
      searchInput: '',
      selectedTaskType: 0,
      tooltipDelay: 700,
      rightClickedTask: null,
      taskTypes: [
        {name: 'My Work', index: 0},
        {name: 'Active', index: 1},
        {name: 'All', index: 3}
      ],
      taskData: []
    }
  },
  computed: {
    currentSearchIsSaved () {
      let ret = false
      let queries = this.$store.getters.taskQueries
      queries.forEach(query => {
        if (query.value === this.searchInput) {
          ret = true
        }
      })
      return ret
    },
    tasks () {
      let user = this.$store.state.authentication.user
      let isRestricted = user.role.attributes.displayName === 'Portal' || user.role.attributes.displayName === 'Restricted'
      let sortOrder = this.$store.getters.taskSortAscending === true ? 1 : -1
      let sortProp = this.$store.getters.taskSortProp
      let orTerms = this.searchInput.trim().toLowerCase().split(/\s+or\s+/) || []

      let ret = this.$store.getters.filteredTasks.filter(task => {
        return orTerms.some(orTerm => {
          let andTerms = orTerm.split(/\s+and\s+|([^:\s])\s+/) || []

          return andTerms.every(andTerm => {
            let andTermParts = andTerm.split(/:\s+/)
            let searchTerm = andTermParts.pop()
            let searchColumn = andTermParts.pop()
            let columnValues = []

            if (!searchColumn || searchColumn === 'client') columnValues.push(task.client)
            if (!searchColumn || searchColumn === 'project') columnValues.push(task.projectPath)
            if (!searchColumn || searchColumn === 'task') columnValues.push(task.name)
            if (!searchColumn || searchColumn === 'activity') columnValues.push(task.defaultActivity ? task.defaultActivity.attributes.name : '')
            if (!searchColumn || searchColumn === 'status') columnValues.push(task.status)
            return (!searchTerm || columnValues.some(columnValue => columnValue && columnValue.toLowerCase().includes(searchTerm))) && (!isRestricted || task.relationships.assignedUsers.data.filter(assignedUser => [user.id].includes(assignedUser.id)).length)
          })
        })
      }).sort((a, b) => a[sortProp] > b[sortProp] ? sortOrder : a[sortProp] < b[sortProp] ? (sortOrder * -1) : a.attributes.priority > b.attributes.priority ? -1 : 0)
      return ret
    },
    isPriorityVisible () {
      let index = this.$store.getters.selectedTaskFilter
      return index === 0
    },
    isStatusVisible () {
      let index = this.$store.getters.selectedTaskFilter
      return index === 0 || index === 3
    },
    selectedTaskFilter: {
      get () {
        return this.$store.getters.selectedTaskFilter
      },
      set (value) {
        this.$store.commit('updateSelectedTaskFilter', value)
      }
    }
  },
  methods: {
    formatStartTime (time) {
      let ret = ''
      if (time) {
        if (time.includes(':')) {
          ret = moment(time).format('YYYY-MM-DD hh:mm')
        } else {
          ret = moment(time).format('YYYY-MM-DD') + ' All Day'
        }
      }
      return ret
    },
    filterAutocomplete (queryString, cb) {
      var queries = this.$store.getters.taskQueries
      var results = queryString ? queries.filter(query => (query.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)) : queries
      // call callback function to return suggestions
      cb(results.sort((a, b) => { return a.date < b.date }))
    },
    saveTaskQuery () {
      this.$store.commit('saveTaskQuery', this.searchInput)
    },
    removeTaskQuery () {
      this.$store.commit('removeTaskQuery', this.searchInput)
    },
    handleRightClick (task) {
      this.rightClickedTask = task
      if (this.$refs && this.$refs.ctxMenu) {
        this.$refs.ctxMenu.open()
      }
    },

    openTaskInLp (task) {
      let workspaceId = String(this.$store.getters.workspaceId)
      if (window && window.process && window.process.type) {
        require('electron').shell.openExternal('https://app.liquidplanner.com/space/' + workspaceId + '/projects/show/' + task.id)
      } else {
        window.open('https://app.liquidplanner.com/space/' + workspaceId + '/projects/show/' + task.id)
      }
    },

    tasksTableClasses ({row, rowIndex}) {
      return row.isPersonal ? 'personal' : ''
    },
    selectTask (task, event) {
      if (event.detail > 1) {
        return
      }

      if (!task.attributes.isDone && !task.attributes.isOnHold) {
        this.onSelect(task)
      } else {
        let status = task.attributes.isDone ? 'inactive' : 'on hold'
        this.$confirm(`This task is ${status}. Do you wish to continue?`).then(() => {
          this.onSelect(task)
        })
      }
    },
    sortData (prop) {
      if (prop === this.$store.getters.taskSortProp) {
        this.$store.commit('toggleTaskSortAscending')
      } else {
        this.$store.commit('setTaskSortAscending', true)
      }
      this.$store.commit('setTaskSortProp', prop)
    },
    singularize: singularize,
    capitalize: capitalize
  },
  mounted () {
    this.$refs.task.focus()
  }
}
</script>

<style lang='scss' >
@import '../styles/common.scss';

$table-margin: 5px;
$table-border: 5px;
$table-padding: 10px;

.tasks {
  height: 100%;
  box-sizing: border-box;

  .entry-search-icon {
    padding: 12px;
    &.saved{
      color:$light-red;
    }
    &.clear{
      padding-right:0px;
    }
  }

  .search-bar {
    display: flex;
    align-items: center;

    .task-select {
      width: 250px;
    }
    .task-search {
      flex-grow: 1;
      margin-left: 10px;
    }
  }
  .vue-recycle-scroller__item-view {
    width: initial !important;
    height: 31px;
    right: 0px;
  }
  .tasks-table {
    height: calc(100vh - 290px);
    color: #606266;
  }
  .table-row {
    display: table;
    table-layout: fixed;
    border-bottom: 1px solid $table-border-color;
    height: 30px;
    width: 100%;

    > div {
      display: table-cell;
      white-space: nowrap;
      vertical-align: middle;
      padding-right: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &.header {
      font-weight: bold;
      color: gray;
      text-transform: uppercase;
      height: 25px;
      margin-top: 10px;

      &:hover {
        background: none;
      }
    }
    &:hover {
      background: $table-hover-color;
    }
    .priority {
      width:90px !important;
    }
    .type{
      width:90px !important;
    }
    .date{
      width:200px !important;
    }
    .task {
      width: 50% !important;
    }
    .activity {
      width:100px !important;
    }
    .status {
      width:80px !important;
    }
    .error {
      color:$error-color;
      font-weight:bold;
    }
    .warning {
      color:$warning-color;
      font-weight:bold;
    }
  }
}
</style>

